// eslint-disable-next-line no-unused-vars
/* globals getMeasurements axios am5 am5themes_Animated */

const measurementCards = document.querySelectorAll('.measurements-card');
const gauges = [];

// eslint-disable-next-line no-unused-vars
const getLeadingZero = (number) => (number < 10 ? `0${number}` : number);

// eslint-disable-next-line require-await
const mapData = async (data) => {
  const [green, red] = ['--color-utility-green', '--color-utility-red'].map((color) => {
    const colors = window.getComputedStyle(document.documentElement);
    return colors.getPropertyValue(color).trim();
  });
  const dataArr = Object.keys(data).map((key) => data[key]);
  const currentData = dataArr[dataArr.length - 1];
  const isOperating = currentData.pop().value;
  const lastUpdate = currentData.pop().value;

  // Update operating status
  const operatingStatusElement = document.querySelector('.mod-status__status');
  operatingStatusElement.innerHTML = isOperating;
  operatingStatusElement.classList.toggle('mod-status__status--yes', isOperating === 'DA');
  operatingStatusElement.classList.toggle('mod-status__status--no', isOperating !== 'DA');

  // Update last update text
  const lastUpdateElement = document.querySelector('.mod-status__right-side span');
  lastUpdateElement.innerHTML = lastUpdate;

  // Map data for gauge chart
  return currentData.map((item) => {
    const value = Number(item.value.replace(',', '.'));
    const limit = Number(item.limit.replace(',', '.'));
    const gradingData = [{ title: '', color: green, lowScore: 0, highScore: limit || 1000 }];

    if (limit) {
      gradingData.push({ title: '', color: red, lowScore: limit, highScore: limit * 1.2 });
    }

    return { score: value, lastUpdate, gradingData };
  });
};

// eslint-disable-next-line no-unused-vars
const lookUpGrade = (lookupScore, grades) => {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < grades.length; i++) {
    if (grades[i].lowScore < lookupScore && grades[i].highScore >= lookupScore) {
      return grades[i];
    }
  }
  return null;
};

const updateGaugeLastMeasurement = ({ gauge }, data) => {
  const lastUpdateElement = gauge.closest('.measurements-card').querySelector('.measurements-card__text span');
  lastUpdateElement.innerHTML = data.lastUpdate;
};

const handleGauge = (gauge, data) => {
  const chartMin = 0;
  const chartMax = data.gradingData[data.gradingData.length - 1].highScore;
  const root = am5.Root.new(gauge);
  // eslint-disable-next-line camelcase
  root.setThemes([am5themes_Animated.new(root)]);

  // Create chart
  // https://www.amcharts.com/docs/v5/charts/radar-chart/
  const chart = root.container.children.push(
    am5radar.RadarChart.new(root, {
      panX: false,
      panY: false,
      startAngle: 135,
      endAngle: 405,
    }),
  );

  // Create axis and its renderer
  // https://www.amcharts.com/docs/v5/charts/radar-chart/gauge-charts/#Axes
  const axisRenderer = am5radar.AxisRendererCircular.new(root, {
    innerRadius: -20,
    minGridDistance: chartMax <= 100 ? 50 : 50,
  });

  // Strokes inside the chart
  axisRenderer.grid.template.setAll({
    stroke: am5.color('#858788'),
    visible: true,
    strokeOpacity: 1,
    strokeWidth: 2,
  });

  const xAxis = chart.xAxes.push(
    am5xy.ValueAxis.new(root, {
      maxDeviation: 0,
      min: chartMin,
      max: chartMax,
      strictMinMax: true,
      renderer: axisRenderer,
    }),
  );

  // Labels/numbers inside the chart
  axisRenderer.labels.template.setAll({
    fontSize: '13px',
    fill: '#161819',
    textType: 'adjusted',
    inside: true,
    radius: chartMax >= 100 ? 40 : 35,
  });

  // Add clock hand
  // https://www.amcharts.com/docs/v5/charts/radar-chart/gauge-charts/#Clock_hands
  const axisDataItem = xAxis.makeDataItem({});
  const clockHand = am5radar.ClockHand.new(root, {
    fill: window.getComputedStyle(document.documentElement).getPropertyValue('--color-primary-text'),
    pinRadius: am5.percent(9),
    radius: am5.percent(55),
    bottomWidth: 12,
  });

  axisDataItem.set('bullet', am5xy.AxisBullet.new(root, { sprite: clockHand }));
  xAxis.createAxisRange(axisDataItem);
  axisDataItem.set('value', data.score);
  chart.bulletsContainer.set('mask', undefined);

  // Create axis ranges bands
  // https://www.amcharts.com/docs/v5/charts/radar-chart/gauge-charts/#Bands
  am5.array.each(data.gradingData, (element) => {
    const axisRange = xAxis.createAxisRange(xAxis.makeDataItem({}));

    axisRange.setAll({
      value: element.lowScore,
      endValue: element.highScore,
    });

    axisRange.get('axisFill').setAll({
      visible: true,
      fill: am5.color(element.color),
      fillOpacity: 1,
    });
  });

  // Update labels
  updateGaugeLastMeasurement({ gauge }, data);
  gauges.push({ gauge, axisDataItem });

  // Make stuff animate on load
  chart.appear(1000, 100);
};

const setupGauges = () => {
  getMeasurements(async (apiData) => {
    const data = await mapData(apiData);

    // If gauges already exist, update them
    if (gauges.length > 0) {
      gauges.forEach((gauge, index) => {
        updateGaugeLastMeasurement(gauge, data[index]);
        gauge.axisDataItem.animate({
          key: 'value',
          to: data[index].score,
          duration: 1000,
          easing: am5.ease.out(am5.ease.cubic),
        });
      });
      return;
    }

    measurementCards.forEach((ele, index) => {
      const gauge = ele.querySelector('.measurements-card__gauge');
      const gaugeData = data[index];

      // Handle error
      if (!gaugeData) {
        ele.remove();
        return;
      }

      handleGauge(gauge, gaugeData);
    });
  });
};

const initMeasurements = () => {
  am5.ready(() => {
    am5.addLicense('AM5C389265151'); // License
    setupGauges();
  });
};

if (typeof am5 !== 'undefined' && measurementCards.length > 0) {
  initMeasurements();
}
